import React from 'react';
import THEME from '../utils/theme';

export default function Loader({ text = 'Loading...' }) {
  return (
    <div style={{
      display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      padding: '64px 24px', gap: 16,
    }}>
      <div style={{
        width: 40, height: 40,
        border: `3px solid ${THEME.redLight}`,
        borderTop: `3px solid ${THEME.red}`,
        borderRadius: '50%',
        animation: 'spin 0.8s linear infinite',
      }} />
      <p style={{ color: '#9CA3AF', fontSize: 14 }}>{text}</p>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
